import { render, staticRenderFns } from "./MyQa.vue?vue&type=template&id=56786ad4"
import script from "./MyQa.vue?vue&type=script&lang=js"
export * from "./MyQa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports